import { openBlock, createElementBlock, createElementVNode } from "vue";
/* empty css               */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const _sfc_main = {};
const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "thumbs-up-icon"
};
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [createElementVNode("g", {
    id: "Thumbs up"
  }, [createElementVNode("path", {
    id: "Icon",
    d: "M5.83317 9.16663L9.1665 1.66663C9.82954 1.66663\n        10.4654 1.93002 10.9343 2.39886C11.4031 2.8677\n        11.6665 3.50358 11.6665 4.16663V7.49996H16.3832C16.6248\n        7.49722 16.8641 7.54705 17.0845 7.64597C17.3049 7.7449\n        17.5012 7.89057 17.6597 8.07289C17.8183 8.2552 17.9353\n        8.46981 18.0026 8.70184C18.07 8.93386 18.0861 9.17776\n        18.0498 9.41663L16.8998 16.9166C16.8396 17.314 16.6377\n        17.6763 16.3314 17.9366C16.0252 18.197 15.6351 18.3378\n        15.2332 18.3333H5.83317M5.83317 9.16663V18.3333M5.83317\n        9.16663H3.33317C2.89114 9.16663 2.46722 9.34222 2.15466\n        9.65478C1.8421 9.96734 1.6665 10.3913 1.6665 10.8333V16.6666C1.6665\n        17.1087 1.8421 17.5326 2.15466 17.8451C2.46722 18.1577 2.89114\n        18.3333 3.33317 18.3333H5.83317",
    "stroke-width": "1.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })], -1)]));
}
const IconThumbsUp = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  IconThumbsUp as default
};
//# sourceMappingURL=IconThumbsUp.mjs.map
